import {
  FlexColumn,
  NumberDisplay,
  TableCell,
  TableRow,
  TextBody,
  TextLabel,
} from "@opensea/ui-kit"
import { useTranslations } from "use-intl"
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants"
import type { PriceDisplay } from "./types"

type Props = {
  prices: PriceDisplay[]
  label?: string
}

export const ReceiptTotalDisplay = ({ prices, label }: Props) => {
  const hasMultipleCurrencies = prices.length > 1
  const t = useTranslations("wallet.ReceiptTotalDisplay")

  return (
    <>
      {prices.map(price => (
        <TableRow key={price.symbol}>
          <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.item}>
            <TextLabel weight="semibold">
              {label ?? t("total")}{" "}
              {hasMultipleCurrencies && `(${price.symbol})`}
            </TextLabel>
          </TableCell>
          <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}>
            <FlexColumn className="text-right">
              <TextBody weight="semibold">
                <NumberDisplay suffix={price.symbol} value={price.unit} />
              </TextBody>
              <TextBody color="text-secondary" weight="regular">
                <NumberDisplay display="usd" value={price.usd} />
              </TextBody>
            </FlexColumn>
          </TableCell>
        </TableRow>
      ))}
    </>
  )
}
